export default "/* purgecss start ignore */\n.logo[data-v-542732e4] {\n  width: 60%;\n  max-width: var(--logo-width-lg);\n}\n\n/* purgecss end ignore */\n"